import { createElement } from 'react';
import { RouteObject, redirect } from 'react-router-dom';

import { isHasAccess, pathPermissions, replacePermissions } from 'features/validateAccess';
import { assignmentService } from 'entities/assignment';
import { positionService } from 'entities/position';

import { pathKeys } from 'shared/lib/react-router';

import AssignmentUpdatePage from './AssignmentUpdatePage';

export const assignmentUpdatePageRoute: RouteObject = {
  path: ':positionId/assignments/:assignmentId/edit/',
  element: createElement(AssignmentUpdatePage),
  loader: async (args) => {
    const requiredPermissions = replacePermissions(pathPermissions.assignment.update, args.params);
    if (!isHasAccess(requiredPermissions)) {
      return redirect(pathKeys.dashboard());
    }

    if (!args.params.positionId || !args.params.assignmentId) {
      return redirect(pathKeys.page404());
    }

    Promise.all([
      positionService.prefetchQuery(args.params.positionId),
      assignmentService.prefetchQuery(args.params.assignmentId),
    ]);

    return args;
  },
};
